export default __webpack_public_path__ + "static/media/img3.10b7065d.jpg";